/**
 * Demo-mode toast notification.
 * Shows a temporary banner when a user tries a write action.
 */

let toastEl: HTMLDivElement | null = null
let hideTimeout: ReturnType<typeof setTimeout> | null = null

export function showDemoToast(message = 'This action is not available in demo mode.') {
  if (hideTimeout) clearTimeout(hideTimeout)

  if (!toastEl) {
    toastEl = document.createElement('div')
    toastEl.style.cssText = `
      position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
      z-index: 99999; padding: 12px 24px; border-radius: 8px;
      background: #013C7A; color: #fff; font-size: 14px; font-family: Inter, sans-serif;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15); transition: opacity 0.3s;
      display: flex; align-items: center; gap: 8px; max-width: 520px;
    `
    document.body.appendChild(toastEl)
  }

  toastEl.innerHTML = `
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    <span><strong>Demo Mode</strong> — ${message}</span>
  `
  toastEl.style.opacity = '1'

  hideTimeout = setTimeout(() => {
    if (toastEl) toastEl.style.opacity = '0'
  }, 3500)
}
